import { IStyle } from "./../Types/Style";
import idx from "idx";
import { IOrganizationTree } from "../api/ResolveApi/resolve-api.types";

import { ObjectAmount } from "../App/actions";
import { IClass, ICourse, IOrganization, IScormPackage, IState } from "../App/reducer";
import { ICompleteOrganization } from "../App/types/common";
import { IFullCourse } from "../components/course-author/types";

export function accountId(state: IState): string {
  return state.App._.user !== null ? state.App._.user.accountId : "";
}

export const accountName = (state: IState): string => (state.App._.user ? state.App._.user.displayName : "");

export const isAdminUser = (state: IState): boolean => !!state.App._.user && state.App._.user.canAccessDashboard;

export const organizationPreview = (state: IState): IOrganizationTree | null => state.App.OrganizationSettings.preview;

export function organizationId(state: IState): string {
  return idx(state, ({ App }) => App._.organization.organizationId) || "";
}

export const isOrgAdmin = (state: IState) => {
  return state.App._.administrableOrgIds.includes(organizationId(state));
};

export const administrableOrgIds = (state: IState) => state.App._.administrableOrgIds;

export const organizationName = (state: IState): string =>
  state.App._.organization ? state.App._.organization.displayName : "";

export const organization = (state: IState): IOrganization | null => state.App._.organization;

export const completeOrganization = (state: IState): ICompleteOrganization | null =>
  state.App.OrganizationSettings.organization;

export function version(state: IState): string {
  return state.App._.skin !== null ? (state.App._.skin.version as string) : "";
}

export function currentCourse(state: IState): IFullCourse {
  return state.App.CourseAuthor._.course!;
}

export function currentCourseId(state: IState): string {
  return state.App.CourseAuthor._.courseId!;
}

export function currentClassId(state: IState): string | null {
  return state.App.ClassManagement.classId;
}

export function currentScormPackageId(state: IState): string | null {
  return state.App.ScormPackageManagement.scormPackageId;
}

export function currentScormPackage(state: IState): IScormPackage | null {
  return state.App.ScormPackageManagement.scormPackage;
}

export function currentClass(state: IState): IClass | null {
  return state.App.ClassManagement.class as IClass;
}
export function currentClassMembers(state: IState): string[] | null {
  return state.App.ClassManagement.class && (state.App.ClassManagement.class.members as string[]);
}
export function changesCount(state: IState): number {
  return state.App.CourseAuthor._.courseChanges.length;
}

export function currentStyleId(state: IState): string | null {
  return state.App.ThemeManagement.styleId;
}

export function eligibileEditorsPreviouslyResolved(state: IState): boolean {
  return state.App.CourseAuthor._.resolvedData.eligibleEditors.length > 0;
}
export const courses = (state: IState): ICourse[] =>
  state.App.Courses._.courses !== null ? state.App.Courses._.courses : [];

export const classes = (state: IState): IClass[] =>
  state.App.Classes._.classes === null ? [] : (state.App.Classes._.classes as IClass[]);

export const themes = (state: IState): IStyle[] => state.App.ThemeList.themes;

export const exportedScormPackages = (state: IState): IScormPackage[] => state.App.ExportedScormPackages.scormPackages;

export const coursesAmount = (state: IState): ObjectAmount => state.App._.objectsAmount.courseAmount;

export const locationSearch = (state: IState) => state.router.location.search;

export const dashboardAllCourseIds = (state: IState) => state.App.Dashboard._.editableByUser;

export const dashboardShownCourseIds = (state: IState) => state.App.Dashboard._.courses.map(course => course.courseId);

export const dashboardFailedCoursesIds = (state: IState) => state.App.Dashboard._.failedCoursesIds;
